import React from 'react';

import fetch from './../fetch';

import moment from 'moment';

import utils from './../../utils';

import {Modal, message, Button} from 'antd';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'evaluatedEmployeeName', label: '被评价人', width: 150},
    {key:'courseName', label: '课程', width: 150},
    {key:'classesName', label: '班级', width: 150},
    {key:'employeeName', label: '操作者', width: 80},
    {key:'operateName', label: '操作', width: 80},
    {key:'resultScore', label: '分数', width: 80},
    {key:'termName', label: '所属学期', width: 130},
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for (var i in keywords) {
            if (i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if (i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('eval/result/queryLog?'+ params.join('&'), keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false,
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    return fetch.post('eval/result/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success(response.message);
            callback();
        }
    });
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('eval/result/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("回退成功！");
        }

        callback();
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('eval/result/remove', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.error({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const getLog = (id) => {
    return fetch.post(`eval/result/getLog/${id}`)
}

export default {
    querySearch,
    batchSubmit,
    batchBack,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    onResultStateSelect,
    getResultStateSelect,
    getLog
}